import type { FC, PropsWithChildren, ReactNode } from 'react';

import { AppImage } from 'components/appImage';

interface IPreviewSideProps extends PropsWithChildren {
  title: ReactNode;
  imageUrl: string;
  alt: string;
}

export const PreviewSide: FC<IPreviewSideProps> = ({ title, imageUrl, alt, children }) => {
  return (
    <div className='flex flex-col gap-y-4 h-full overflow-hidden max-sm:max-h-full max-sm:h-auto'>
      <h4 className='text-primary-text text-xl leading-[26px] font-bold text-center'>{title}</h4>
      <div className='size-full py-1 bg-black/[0.08] overflow-hidden relative max-sm:h-auto max-sm:max-h-full max-sm:mt-auto'>
        <AppImage
          canCopy={false}
          draggable={false}
          className='block min-w-full object-contain max-h-full max-sm:h-[240px]'
          src={imageUrl}
          alt={alt}
        />
        {children}
      </div>
    </div>
  );
};
